export default "__VITE_ASSET__B1pUr0PZ__"